import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button1 from "../Buttons/Button1";
import MobileBackButton from "../../NewComponents/Common/MobileBackButton";

const BasicHeader = () => {
  const navigate = useNavigate();

  const handleCartClick = () => {
    navigate("/coming-soon");
  };

  return (
    <>
      <div className="bg-white flex justify-between shadow-shadowColor shadow-md z-50 top-0 sticky items-center px-3">
        <div className="flex items-center gap-2 ml-2 lg:ml-10">
          <MobileBackButton size={28} />
          <img
            src="/a2z-logo.png"
            alt="A2Z Villaz"
            className="h-[50px] w-[50px] rounded-full object-cover hover:cursor-pointer"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
        <div className="flex flex-row  justify-center mt-4  mr-10">
          <div
            className="mr-5 hover:cursor-pointer scale-[0.9] "
            onClick={() => {
              handleCartClick();
            }}
          >
            <img src="/cart.svg"></img>
          </div>
          <div className="ml-4">
            <Link to="/signup" className="mr-5 scale-[0.8] md:scale-90">
              <Button1 value="Login/Signup" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicHeader;
